import { Component } from '@verndale/core'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $tbody: this.el.querySelector('tbody'),
      $thead: this.el.querySelector('thead')
    }

    this.mobile = window.innerWidth < 768
    this.createMobileVersion()
  }

  createMobileVersion() {
    this.originalVersion = this.dom.$tbody.cloneNode(true)
    this.mobileVersion = this.dom.$tbody.cloneNode(true)

    const headerRows = this.dom.$thead?.querySelectorAll('tr')
    const headerHeaders =
      headerRows?.length > 1
        ? headerRows[headerRows.length - 1]?.querySelectorAll('th')
        : headerRows?.querySelectorAll('th')
    this.mobileVersion.querySelectorAll('td').forEach((cell, index) => {
      if (headerHeaders?.length > 0) {
        const header = headerHeaders[index % headerHeaders?.length]
        cell.innerHTML = `<span class="th">${header?.innerHTML}: </span> ${cell?.innerHTML}`
      }
    })

    if (this.mobileVersion) {
      this.dom.$tbody.innerHTML = this.mobileVersion.innerHTML
    }
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  handleResize() {
    if (window.innerWidth < 768 && !this.mobile) {
      this.mobile = true
      this.dom.$tbody.innerHTML = this.mobileVersion.innerHTML
    } else if (window.innerWidth > 768 && this.mobile) {
      this.dom.$tbody.innerHTML = this.originalVersion.innerHTML
    }
  }
}

export default Module
